import { UPDATE_EXCHANGE_RATE } from "./exchangeRateActionTypes";

export const updateExchangeRate = exchangeRate => {
	return {
		type: UPDATE_EXCHANGE_RATE,
		exchangeRate,
	};
};
